import React from "react"
import Form from "react-bootstrap/Form";
import {useTheme} from "@material-ui/core/styles";


const isDateType = (type) => type === 'date' || type === 'datetime-local';

const hasValidYear = (value) => {
  if (!value) return true;
  const yearStr = value.split('-')[0];
  return yearStr.length <= 4;
};

const TextField = ({type,value,name,onChange, id, disabled, submitted=false, ...rest}) => {
  const theme = useTheme();

  const them = !theme ? {} : theme;

  const palette = !them.palette ? {} : them.palette;

  const isSubmitted = submitted && !value;

  const handleChange = (e) => {
    if (isDateType(type) && !hasValidYear(e.target.value)) {
      return; // reject dates with 5+ digit years
    }
    onChange(e);
  };

  return (
    <Form.Control
      style={{border: isSubmitted ? '1px solid red':''}}
      id={id}
      data-testid={id}
      type={type}
      value={value}
      name={name}
      onChange={handleChange}
      className={`form__control ${palette.type === "dark" && 'form-control-dark'}`}
      disabled={disabled}
      {...rest}
    />
  )
};
export default TextField;
